import Taro from '@tarojs/taro'

export default function showNotification(icon: Taro.showToast.Option['icon'], title: string) {
  Taro.showToast({
    icon,
    title,
  })
}
